import React, { useState, useEffect } from 'react';
import "./portfolio.css";

import Pong from '../../images/project-1.png';
import MTFC from '../../images/project-2.png';
import Bazara from '../../images/project-3.png';
import Notes from '../../images/project-4.jpg';
import TicTac from '../../images/project-5.jpg';
import Money1 from '../../images/project-6.jpg';
import Money2 from '../../images/project-7.jpg';
import Campus from '../../images/project-8.jpg';

function Portfolio(props) {

  const projects = [
    {
      name: "Game Pong : Pukul Bola (2020)",
      tools: "Unity, C#",
      desc: "Game Pong : Pukul Bola, dibuat menggunakan Unity sebagai tugas submission kelas dicoding",
      repository: "https://github.com/ufarqrobbany/pong_game",
      image: Pong
    },
    {
      name: "MTFC Indramayu (2023)",
      tools: "Codeigniter 4, Bootstrap 5",
      desc: "Website Profil Mangoes Taekwondo Fans Club",
      demo: "https://revolty.000webhostapp.com",
      image: MTFC
    },
    {
      name: "Bazara (2023)",
      tools: "ReactJS, Tailwind CSS",
      desc: "Website E-Commerce Bazara.id",
      ui: "https://shorturl.at/nxCX7",
      screenshot: "https://drive.google.com/drive/folders/1jU4rcBZbc1GDgaxjKOnes8t_XOF8c1rX?usp=sharing",
      image: Bazara
    },
    {
      name: "Notes App (2023)",
      tools: "Flutter",
      desc: "Aplikasi catatan android",
      repository: "https://github.com/ufarqrobbany/notes_app",
      download: "https://drive.google.com/drive/folders/1MxKau9WQ173GD69u7_1JOhQrHZ9H55fz?usp=sharing",
      image: Notes
    },
    {
      name: "Tic Tac Toe (2023)",
      tools: "C",
      desc: "Game Tic Tac Toe terminal sebagai Tugas Besar Mata Kuliah Dasar-Dasar Pemrograman",
      repository: "https://github.com/ufarqrobbany/TicTacToe_DedeGacor88",
      image: TicTac
    },
    {
      name: "Money Tracking App (2024)",
      tools: "C",
      desc: "Aplikasi terminal untuk mencatat dan mengelola keuangan sebagai Tugas Mata Kuliah Proyek 1 : Pengembangan Perangkat Lunak Desktop",
      repository: "https://github.com/ufarqrobbany/a2-money-tracking",
      image: Money1
    },
    {
      name: "Money Tracking App 2 (2024)",
      tools: "Python",
      desc: "Aplikasi terminal untuk mencatat dan mengelola keuangan sebagai Tugas Mata Kuliah Proyek 1 : Pengembangan Perangkat Lunak Desktop",
      repository: "https://github.com/ufarqrobbany/a2_money_tracking_py",
      image: Money2
    },
    {
      name: "Campus Food (2024)",
      tools: "Figma",
      desc: "Desain UI aplikasi Campus Food untuk PKM-KI",
      ui: "https://shorturl.at/mFRSX",
      image: Campus
    },
  ];

  return(
    <div className='portfolio-container' id="portfolio">
      {/* <div className='circle-container-portfolio'>
        <div className='circle-portfolio circle-portfolio-1'></div>
        <div className='circle-portfolio circle-portfolio-2'></div>
        <div className='circle-portfolio circle-portfolio-3'></div>
        <div className='circle-portfolio circle-portfolio-4'></div>
      </div> */}

      <div className='portfolio-card' style={{zIndex: 2}}>
        <h2 style={{zIndex: 2}}>Portfolio</h2>
        <div className="desc" style={{zIndex: 2}}>
          <span className="line" style={{zIndex: 2}}></span>
          Showcase my work
        </div>
        <div className='portfolio-list' style={{zIndex: 2}}>
          {
            projects.map((item, index) => (
              <div className='portfolio-item' style={{zIndex: 2}}>
                <div className='portfolio-image' style={{zIndex: 200}}>
                  {/* {item.image && <img src={item.image} />} */}
                </div>
                <div className='portfolio-detail' style={{zIndex: 2}}>
                  <div className='project-name' style={{zIndex: 2}}>{item.name}</div>
                  <div className='project-tools' style={{zIndex: 2}}>{item.tools}</div>
                  <div className='project-desc' style={{zIndex: 2}}>{item.desc}</div>
                  <div className='project-link' style={{zIndex: 2}}>
                    {item.repository && <a href={item.repository} target='_blank'>Repository <i class="fa-solid fa-up-right-from-square"></i></a>}
                    {item.demo && <a href={item.demo} target='_blank'>Demo <i class="fa-solid fa-up-right-from-square"></i></a>}
                    {item.ui && <a href={item.ui} target='_blank'>UI Design <i class="fa-solid fa-up-right-from-square"></i></a>}
                    {item.screenshot && <a href={item.screenshot} target='_blank'>Screenshot & Video <i class="fa-solid fa-up-right-from-square"></i></a>}
                    {item.download && <a href={item.download} target='_blank'>Download <i class="fa-solid fa-up-right-from-square"></i></a>}
                  </div>
                </div>
              </div>
            ))
          }
        </div>
        <iframe style={{zIndex: 2}} width="560" height="315" src="https://www.youtube.com/embed/XVv6mJpFOb0?si=L4NNZytk8n310qE1" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
      </div>

      
    </div>
  );
}

export default Portfolio;
